/**
 * Contacts Module Routes
 *
 * Route definitions for the Contacts module.
 * All routes are relative to the module path (/contacts).
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/contacts',
        component: ModuleLayout,
        meta: {
            moduleKey: 'contacts',
        },
        children: [
            {
                path: '',
                name: 'contacts-list',
                component: () => import('./views/ContactList.vue'),
                meta: {
                    title: 'All Contacts',
                },
            },
            {
                path: 'create',
                name: 'contacts-create',
                component: () => import('./views/ContactCreate.vue'),
                meta: {
                    title: 'Add Contact',
                    moduleKey: 'contacts',
                },
            },
            {
                path: ':id',
                name: 'contacts-detail',
                component: () => import('./views/ContactDetail.vue'),
                meta: {
                    title: 'Contact Details',
                },
            },
        ],
    },
]

export default routes
